import { useEffect, useState } from "react";
import { AdvancedFilterOptions } from "../../../Common/models/advancedFilters";
import { getAdvancedFilters } from "../api/adminUserSearchClient";

export const useAdminAdvancedFiltersSearch = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<AdvancedFilterOptions>({ packages: [], tools: [], projectUserRoles: [], modes: [] });

  const fetchFilters = async () => {
    setIsLoading(true);
    try {
      const result = await getAdvancedFilters();
      setData(result);
    } catch {
      setData({ packages: [], tools: [], projectUserRoles: [], modes: [] });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  return {
    data,
    isLoading,
  };
};
